__turbopack_context__.v({
  "active": "HeaderMenu-module-scss-module__IAlfQW__active",
  "link": "HeaderMenu-module-scss-module__IAlfQW__link",
});
